import { render, staticRenderFns } from "./LocationDetail.vue?vue&type=template&id=6da5f8a0&scoped=true"
import script from "./LocationDetail.vue?vue&type=script&lang=js"
export * from "./LocationDetail.vue?vue&type=script&lang=js"
import style0 from "./LocationDetail.vue?vue&type=style&index=0&id=6da5f8a0&prod&scoped=true&lang=css"
import style1 from "./LocationDetail.vue?vue&type=style&index=1&id=6da5f8a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da5f8a0",
  null
  
)

export default component.exports